import { modal } from "..";
import { t } from "../locale";
import { Bulma } from "../view/bulma";
import { Html } from "../view/html";

/**
 * @param {() => void} unregister
 */
function openUnregisterDeviceModal(unregister) {
	modal.open({
		header: t.device.settingsPage.removeDeviceLabel,
		body: [Html.paragraph(t.device.settingsPage.deviceRemovalDisclaimer)],
		footer: [
			Bulma.button(
				{
					onClick: unregister,
					styles: ["is-danger"],
				},
				t.remove,
			),
		],
	});
}

export { openUnregisterDeviceModal };
